module.exports = __webpack_public_path__ + "media/images/vector-15@2x-66e2cb142ec7996b938dc293bacc580b.png";